import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';

export const ApiDocumentationPage = () => {
  return <SwaggerUI url="/api/v4/api-docs" />;
};
